import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";

import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {IoWarningOutline} from "react-icons/io5";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {BiSolidSelectMultiple} from "react-icons/bi";
import EmptyPic from "../../Assets/Images/emptypic.png"
import {LiaUserEditSolid} from "react-icons/lia";
import {FaArrowLeftLong, FaMapLocation} from "react-icons/fa6";


const currencyFormat = Intl.NumberFormat('en-US');
function ManagerVendor() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [title, setTitle] = React.useState('');
    const [isActive, setIsActive] = React.useState(0);
    const [isTempActive, setIsTempActive] = React.useState(0);
    const [brief, setBrief] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [cashDiscount, setCashDiscount] = React.useState(0);
    const [minPurchase, setMinPurchase] = React.useState(0);
    const [chequeDeadline, setChequeDeadline] = React.useState(45);
    const [description, setDescription] = React.useState('');
    // const [officePhone, setOfficePhone] = React.useState([]);
    const [supportPhone, setSupportPhone] = React.useState('');
    const [logo, setLogo] = React.useState(null);
    const [fileLogo, setFileLogo] = React.useState(null);
    const [picLogo, setPicLogo] = React.useState(EmptyPic);
    const [cover, setCover] = React.useState(null);
    const [fileCover, setFileCover] = React.useState(null);
    const [picCover, setPicCover] = React.useState(EmptyPic);
    const [thresholdDiscount, setThresholdDiscount] = React.useState(0);
    const [discountPercent, setDiscountPercent] = React.useState(0);
    const [tax, setTax] = React.useState(0);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        API.getUserInfo()
            .then((response) => {

                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

        const params = {
            processFor: 'Suppliers',
            vendor_id: window.localStorage.getItem("vendor")
        }

        API.getVendor(params)
            .then((response) => {
                setIsLoaded(true);
                const vendor = response.data;
                setTitle(vendor.title)
                setSupportPhone(vendor.support_phone)
                setAddress(vendor.address)
                setBrief(vendor.brief)
                setTax(vendor.tax_percent)
                setIsActive(vendor.is_active)
                setIsTempActive(vendor.is_temp_active)
                setDescription(vendor.description)
                setLogo(vendor.image)
                setCover(vendor.cover_photo)
                setCashDiscount(vendor.cash_discount_percent)
                setChequeDeadline(vendor.cheque_deadline)
                setMinPurchase(vendor.minimum_order_amount)
                setThresholdDiscount(vendor.threshold_discount)
                setDiscountPercent(vendor.discount_percent)
            })
            .catch((error) => {
                setTimeout (() => {
                    navigate(`/vendor/select`)
                },400)
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });


    }, []);

    const onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            setPicLogo(reader.result);
            setFileLogo(event.target.files[0])
        };
    }
    const onFileChangeCover = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            setPicCover(reader.result);
            setFileCover(event.target.files[0])
        };
    }

    const onClickSaveButton = () => {
        setIsLoaded(false);

        const formData = new FormData();
        if (fileLogo)
            formData.append('logo', fileLogo);
        if (fileCover)
            formData.append('cover', fileCover);
        formData.append('title', title);
        formData.append('description', description);
        formData.append('brief', brief);
        formData.append('support_phone', supportPhone);
        formData.append('address', address);
        formData.append('province_id', 2);
        formData.append('city_id', 1);
        formData.append('minimum_order_amount', minPurchase);
        formData.append('tax_percent', tax);

        formData.append('cash_discount_percent', cashDiscount);
        formData.append('cheque_deadline', chequeDeadline);
        formData.append('vendor_id', window.localStorage.getItem("vendor"));
        formData.append('discount_percent', discountPercent);
        formData.append('threshold_discount', thresholdDiscount);

        API.updateVendor(formData)
            .then((response) => {
                toast.success(response.message);

                setTimeout (() => {
                    window.location.replace(`/vendor/manage`);
                },1500)
            })
            .catch((error) => {
                setIsLoaded(true);
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
    }

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         id='active'
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}
                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5">
                        {
                            isLoaded && !isActive &&
                            <div className="alert alert-warning text-center text-small-2">
                                <div>
                                    <IoWarningOutline className='text-big-5 mb-3' />
                                </div>
                                اطلاعات مجموعه شما هنوز تایید نهایی نشده است. تا تایید توسط مدیریت سامانه منتظر بمانید
                                {
                                    isTempActive && <div className='fw-bold text-success'>

                                    تایید موقت جهت ثبت کالا
                                    </div>
                                }
                            </div>
                        }

                        <div className="row product-form main-part ">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                                مدیریت اطلاعات مجموعه

                            </div>

                            <div className="col-md-6 mb-3">

                                <img alt="Logo"
                                     src={(logo && !fileLogo) ? logo : picLogo}
                                     width={120} className='rounded'/>
                                <span className="px-2">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر لوگوی جدید
                                                 <input type="file" onChange={onFileChange}/>
                                                </label>
                                            </span>
                            </div>
                            <div className="col-md-6 ">

                                <img alt="Logo"
                                     src={(cover && !fileCover) ? cover : picCover}
                                     width={120} className='rounded'/>
                                <span className="px-2">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر کاور جدید
                                                 <input type="file" onChange={onFileChangeCover}/>
                                                </label>
                                            </span>
                            </div>
                            <div className="col-12 my-3 fw-bold text-small-1 alert alert-primary"
                            onClick={() => {
                                navigate('/select-area')
                            }}
                            >
                                <FaMapLocation className='mx-2'  />
                                برای محدود کردن منطقه هایی که در آنها فروش انجام می شود اینجا کلیک کنید
                                <FaArrowLeftLong className='mx-2 float-start mt-3' />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    عنوان
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={title}
                                           onChange={
                                               (event) => {
                                                   setTitle(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    شماره تلفن
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={supportPhone}
                                           onChange={
                                               (event) => {
                                                   setSupportPhone(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>

                            <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    آدرس
                                </label>
                                <div className="form-floating mb-3">
                                    <textarea
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={address}
                                        onChange={
                                            (event) => {
                                                setAddress(event.target.value)
                                            }
                                        }
                                    >
                                    </textarea>

                                </div>
                            </div>

                            <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    توضیحات مختصر
                                </label>
                                <div className="form-floating mb-3">
                                    <textarea type="text"
                                              className="form-control text-center text-small-1"
                                              id="floatingInput"

                                              value={brief}
                                              onChange={
                                                  (event) => {
                                                      setBrief(event.target.value)
                                                  }
                                              }
                                    >
                                    </textarea>

                                </div>
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    درصد تخفیف در صورت خرید نقدی
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={cashDiscount}
                                           onChange={
                                               (event) => {
                                                   setCashDiscount(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    مهلت چک در خرید غیر نقدی (روز)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={chequeDeadline}
                                           onChange={
                                               (event) => {
                                                   setChequeDeadline(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    حداقل مبلغ خرید (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={minPurchase}
                                           onChange={
                                               (event) => {
                                                   setMinPurchase(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                                <div className='price-hint mt-2'>
                                    {currencyFormat.format(Math.round(minPurchase / 10))}
                                    &nbsp;
                                    تومان
                                </div>
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    آستانه تخفیف مبلغی (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={thresholdDiscount}
                                           onChange={
                                               (event) => {
                                                   setThresholdDiscount(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                                <div className='price-hint mt-2'>
                                    {currencyFormat.format(Math.round(thresholdDiscount / 10))}
                                    &nbsp;
                                    تومان
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    درصد تخفیف مبلغی
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={discountPercent}
                                           onChange={
                                               (event) => {
                                                   setDiscountPercent(event.target.value)
                                               }
                                           }
                                    />

                                </div>

                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    درصد مالیات
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={tax}
                                           onChange={
                                               (event) => {
                                                   setTax(event.target.value)
                                               }
                                           }
                                    />

                                </div>

                            </div>

                            <div className="col-12">
                                <label htmlFor="floatingInput">
                                    توضیحات
                                </label>
                                <div className="form-floating mb-3">
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                        }}
                                    />


                                </div>
                            </div>
                            <div className="col-6">
                                &nbsp;
                            </div>
                            <div className="col-6">
                                <button className='btn btn-success w-100'
                                        onClick={onClickSaveButton}
                                >
                                    به روز رسانی اطلاعات
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default ManagerVendor;